import { useQuery } from '@tanstack/react-query';

import { $$api } from '@doger/core/shared/api';

import { useJWTTokens } from './jwt';

export const useUserQueryKey = () => {
  const tokens = useJWTTokens();

  return {
    queryKey: ['auth', 'user', tokens.accessToken],

    meta: {
      accessToken: tokens.accessToken,
    },
  };
};

export const useUser = () => {
  const { queryKey, meta } = useUserQueryKey();

  return useQuery({
    queryKey,
    queryFn: async () => {
      if (!meta.accessToken) {
        return null;
      }

      return $$api.getProfile();
    },
    refetchOnWindowFocus: 'always',
  });
};
